import {Stack} from '../../layout/stack/stack';
import type {StackSpacing} from '../../layout/stack/stack';
import {Body} from '../../typography/body';

import {CELL_WIDTH} from './calendar-heatmap';

const DAYS_OF_WEEK = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

interface Props {
    cellGap?: StackSpacing;
}

export function CalendarHeatmapWeekLabel(props: Props) {
    return (
        <Stack isHorizontal={true} spacing={props.cellGap} alignItems='center'>
            {DAYS_OF_WEEK.map((day, i) => (
                <div
                    key={i}
                    className='flex align-center justify-center'
                    style={{
                        width: CELL_WIDTH,
                    }}
                >
                    <Body color='medium' textAlign='center'>
                        {day}
                    </Body>
                </div>
            ))}
        </Stack>
    );
}
